import { Component,AfterViewInit,OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements AfterViewInit, OnInit {

  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }
}

